export class CustomError extends Error {
    public code: string;

    constructor(message: string = '', code: string) {
        super(message);
        this.code = code;
        this.name = 'CustomError';
    }
}

export class UserDocNotFoundError extends CustomError {
    constructor(message: string = '') {
        super(message, 'USER_DOC_NOT_FOUND');
        this.name = 'UserDocNotFoundError';
    }
}

export class UserNotSignedInError extends CustomError {
    constructor(message: string = '') {
        super(message, 'USER_NOT_SIGNED_IN');
        this.name = 'UserNotSignedInError';
    }
}

export class UserNonExistingIdError extends CustomError {
    constructor(message: string = '') {
        super(message, 'USER_NON_EXISTING_ID');
        this.name = 'UserNonExistingIdError';
    }
}
